class ObjectUtils {
    static getMaxSizeSubArray(obj) {
        let max = 0;
        Object.keys(obj).forEach((prop) => {
            if (obj[prop].constructor === Array && obj[prop].length > max)
                max = obj[prop].length;
        });
        return max;
    }

    static isJSON(str) {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }

    /**
     * Realiza una copia plana del objeto. Si el mismo contiene atributos de tipo coleccion las mismas
     * no seran copiadas, por lo tanto quedaran referenciando la misma coleccion.
     * Lo mismo para los atributos de tipo objeto, en la copia quedaran referenciando al mismo objeto
     * que el original.
     * Si obj no es un objeto se retornará el mismo obj
     *
     */
    static plainCopy(obj) {
        if (null == obj || "object" != typeof obj) return obj;
        return Object.assign({}, obj);
    }
}

export default ObjectUtils;
